module.exports = __webpack_public_path__ + "static/img/上海银行@2x.2009b014.png";